import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { Reviews } from './components/Reviews';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixel = ((...args: unknown[]) => void) & {
  queue?: unknown[][];
  callMethod?: (...args: unknown[]) => void;
  push?: unknown;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
const META_PIXEL_ID = '2615553752214113';
let pixelInitialized = false;
export function App() {
  useEffect(() => {
    if (pixelInitialized) return;
    pixelInitialized = true;
    if (!window.fbq) {
      const fbq: MetaPixel = (...args: unknown[]) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue?.push(args);
        }
      };
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq?.('init', META_PIXEL_ID);
    window.fbq?.('track', 'PageView');
  }, []);
  return <main className="w-full overflow-x-hidden bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="swqc3h7othxg">
      <noscript data-id="element-1" data-mp="34napqbl6vw3">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="38b5essrpoce" />
      </noscript>
      <Hero data-id="element-3" data-mp="85ujnspgu14c" />
      <ProfessionalAudience data-id="element-4" data-mp="85bbv4tj4t41" />
      <StatsBar data-id="element-5" data-mp="864afiic4cb3" />
      <TestimonialStrip data-id="element-6" data-mp="83i39jzcvyte" />
      <Problems data-id="element-7" data-mp="3gle9siuub3f6" />
      <Modules data-id="element-8" data-mp="3gkv1zuywlvev" />
      <ModuleIncludes data-id="element-9" data-mp="3gmfulf1nr4a3" />
      <Comparison data-id="element-10" data-mp="3glwfs77b0w0a" />
      <Bonuses data-id="element-11" data-mp="3gj1sm7wwox36" />
      <PricingPack data-id="element-12" data-mp="3bmbalf1jjrf4" />
      <Guarantee data-id="element-13" data-mp="3bn2y02kziiub" />
      <Reviews data-id="element-14" data-mp="3bnmh3mmdfd9x" />
      <CostOfNotBuying data-id="element-15" data-mp="3bnurn7v0u6hy" />
      <FAQ data-id="element-16" data-mp="3bkgss9lkgff9" />
      <FinalCTA data-id="element-17" data-mp="3qb7m5m2t3mkh" />
      <Footer data-id="element-18" data-mp="3qbpq74vpn52y" />
    </main>;
}